<script setup lang="ts">
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarGroupLabel,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from '@manta/ui-kit';
import { Mic, LayoutTemplate, Settings } from 'lucide-vue-next';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import LogoHeader from './LogoHeader.vue';
import NavUser from './NavUser.vue';
import TheTenantSelector from './TheTenantSelector.vue';

const route = useRoute();
const { t } = useI18n();
</script>

<template>
  <Sidebar collapsible="icon">
    <SidebarHeader>
      <LogoHeader />
    </SidebarHeader>
    <SidebarContent>
      <SidebarGroup>
        <SidebarGroupLabel>{{ t('nav.workspace') }}</SidebarGroupLabel>
        <SidebarGroupContent>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton
                as-child
                :is-active="route.path.startsWith('/scribe/sessions')"
                :tooltip="t('nav.sessions')"
              >
                <RouterLink to="/scribe/sessions">
                  <Mic />
                  <span>{{ t('nav.sessions') }}</span>
                </RouterLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButton
                as-child
                :is-active="route.path.startsWith('/scribe/templates')"
                :tooltip="t('nav.templates')"
              >
                <RouterLink to="/scribe/templates">
                  <LayoutTemplate />
                  <span>{{ t('nav.templates') }}</span>
                </RouterLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
            <SidebarMenuItem>
              <SidebarMenuButton
                :tooltip="t('nav.settings')"
                class="cursor-not-allowed opacity-50"
                :disabled="true"
              >
                <Settings />
                <span>{{ t('nav.settings') }}</span>
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarGroupContent>
      </SidebarGroup>
    </SidebarContent>
    <SidebarFooter>
      <TheTenantSelector />
      <NavUser />
    </SidebarFooter>
  </Sidebar>
</template>
